/* LOOKEE® homepage, "See your night": motion and interaction for the ln-* sections.
   Smooth scroll (Lenis) and GSAP ScrollTrigger + SplitText, loaded from jsDelivr only on pages that use these
   sections. Every effect has a still version: the visitor's reduce-motion setting, the footer switch, the theme
   editor, or a library that fails to load all give the still page, fully readable. The night chart, the limit
   slider and the video button work in every mode. */
(function () {
  if (window.__lnHome) return;
  window.__lnHome = true;

  var html = document.documentElement;
  var CDN = 'https://cdn.jsdelivr.net/npm/';
  var LIBS = [CDN + 'gsap@3.13.0/dist/gsap.min.js', CDN + 'gsap@3.13.0/dist/ScrollTrigger.min.js',
    CDN + 'gsap@3.13.0/dist/SplitText.min.js'];
  if (document.body && document.body.classList.contains('ln-page')) LIBS.push(CDN + 'lenis@1.3.4/dist/lenis.min.js');
  var design = !!(window.Shopify && window.Shopify.designMode);
  var still = !html.classList.contains('ln-anim') || design || html.getAttribute('data-motion') === 'off';
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function goStill() { still = true; html.classList.remove('ln-anim'); html.classList.add('ln-loaded'); }
  if (still) goStill();

  /* ---------------------------------------------------------------- one illustrated night
     10:00 PM to 6:30 AM, one point every 2 minutes. Not real data. The dips are placed so that a limit of
     88% gives 1 vibration, 89% gives 2, 90% gives 3, 91% gives 4 and 92% gives 5. */
  var N = (function () {
    var START = 22 * 60, LENGTH = 510, STEP = 2, seed = 7;
    function rand() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
    var dips = [[162, 92.0, 7], [254, 87.0, 9], [300, 91.5, 6], [342, 89.2, 8], [380, 90.6, 6], [416, 88.4, 9], [456, 92.5, 6]];
    var o2 = [], pr = [], n = LENGTH / STEP + 1, drift = 0, pdrift = 0;
    for (var i = 0; i < n; i++) {
      var m = i * STEP;
      var asleep = Math.min(1, Math.max(0, (m - 20) / 40)), waking = Math.min(1, Math.max(0, (m - 470) / 40));
      drift = drift * 0.82 + (rand() - 0.5) * 0.55;
      var base = 97.2 - asleep * 1.5 + waking * 1.2 + Math.sin(m / 37) * 0.35 + drift, v = base, bump = 0;
      for (var d = 0; d < dips.length; d++) {
        var k = Math.exp(-Math.pow((m - dips[d][0]) / dips[d][2], 2));
        v = v - (base - dips[d][1]) * k;
        bump += 9 * Math.exp(-Math.pow((m - dips[d][0] - 4) / (dips[d][2] + 2), 2));
      }
      pdrift = pdrift * 0.8 + (rand() - 0.5) * 2.2;
      o2.push(Math.round(Math.min(99.4, v) * 10) / 10);
      pr.push(Math.round(73 - asleep * 13 + waking * 9 + Math.sin(m / 23) * 1.4 + pdrift + bump));
    }
    dips.forEach(function (d) { o2[Math.round(d[0] / STEP)] = d[1]; });
    function clock(m) {
      var t = (START + m) % 1440, h = Math.floor(t / 60), min = t % 60;
      return { time: (h % 12 === 0 ? 12 : h % 12) + ':' + (min < 10 ? '0' : '') + min, ampm: h >= 12 ? 'PM' : 'AM' };
    }
    function episodes(limit) {
      var list = [], inside = false, start = 0, lowI = 0;
      for (var i = 0; i < o2.length; i++) {
        if (o2[i] < limit) { if (!inside) { inside = true; start = i; lowI = i; } if (o2[i] < o2[lowI]) lowI = i; }
        else if (inside) { inside = false; list.push({ start: start, end: i - 1, low: lowI }); }
      }
      if (inside) list.push({ start: start, end: o2.length - 1, low: lowI });
      return list;
    }
    return { o2: o2, pr: pr, step: STEP, clock: clock, episodes: episodes };
  })();

  var SVGNS = 'http://www.w3.org/2000/svg';
  function el(name, attrs, parent) { var e = document.createElementNS(SVGNS, name); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }

  /* ---------------------------------------------------------------- the night chart */
  function buildNight(root) {
    var svg = $('[data-ln-chart-svg]', root);
    if (!svg || svg.__built) return null;
    svg.__built = true;
    var limit = Number(root.getAttribute('data-limit')) || 90;
    var O2_TOP = 14, O2_BOT = 236, O2_MAX = 100, O2_MIN = 84, PR_TOP = 266, PR_BOT = 334, PR_MAX = 90, PR_MIN = 48;
    function yO2(v) { return O2_TOP + (O2_MAX - v) / (O2_MAX - O2_MIN) * (O2_BOT - O2_TOP); }
    function yPR(v) { return PR_TOP + (PR_MAX - v) / (PR_MAX - PR_MIN) * (PR_BOT - PR_TOP); }
    var n = N.o2.length;
    function xAt(i) { return i / (n - 1) * 1000; }
    var uid = 'ln' + Math.random().toString(36).slice(2, 7);
    var defs = el('defs', {}, svg);
    var grad = el('linearGradient', { id: 'ln-o2fill', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
    el('stop', { offset: '0', 'stop-color': '#fe5000', 'stop-opacity': '.32' }, grad);
    el('stop', { offset: '1', 'stop-color': '#fe5000', 'stop-opacity': '0' }, grad);
    var clip = el('clipPath', { id: uid + '-reveal' }, defs);
    var clipRect = el('rect', { x: 0, y: -20, width: 1000, height: 400 }, clip);
    [100, 95, 90, 85].forEach(function (v) { el('line', { x1: 0, x2: 1000, y1: yO2(v), y2: yO2(v), class: 'ln-c-grid' }, svg); });
    el('line', { x1: 0, x2: 1000, y1: PR_TOP - 12, y2: PR_TOP - 12, class: 'ln-c-grid' }, svg);
    el('line', { x1: 0, x2: 1000, y1: yO2(limit), y2: yO2(limit), class: 'ln-c-limit' }, svg);
    var dO2 = '', dPR = '';
    for (var i = 0; i < n; i++) { dO2 += (i ? 'L' : 'M') + xAt(i).toFixed(1) + ' ' + yO2(N.o2[i]).toFixed(1); dPR += (i ? 'L' : 'M') + xAt(i).toFixed(1) + ' ' + yPR(N.pr[i]).toFixed(1); }
    var g = el('g', { 'clip-path': 'url(#' + uid + '-reveal)' }, svg);
    el('path', { d: dO2 + 'L1000 ' + O2_BOT + 'L0 ' + O2_BOT + 'Z', class: 'ln-c-area' }, g);
    el('path', { d: dPR, class: 'ln-c-pr' }, g);
    el('path', { d: dO2, class: 'ln-c-o2' }, g);
    var events = N.episodes(limit);
    var eventLines = events.map(function (ep) { return el('line', { x1: xAt(ep.low), x2: xAt(ep.low), y1: yO2(N.o2[ep.low]) + 6, y2: O2_BOT, class: 'ln-c-event' }, g); });
    var head = el('line', { x1: 0, x2: 0, y1: 0, y2: PR_BOT, class: 'ln-c-head' }, svg);
    var overlay = document.createElement('div');
    overlay.className = 'ln-chart__overlay';
    overlay.setAttribute('aria-hidden', 'true');
    svg.parentNode.insertBefore(overlay, svg.nextSibling);
    function pct(y) { return (y / 340 * 100).toFixed(2) + '%'; }
    [100, 95, 90, 85].forEach(function (v) { var s = document.createElement('span'); s.className = 'ln-ov-y'; s.style.top = pct(yO2(v)); s.textContent = v + '%'; overlay.appendChild(s); });
    var lim = document.createElement('span'); lim.className = 'ln-ov-limit'; lim.style.top = pct(yO2(limit));
    lim.textContent = (root.getAttribute('data-limit-label') || 'Your limit') + ', ' + limit + '%'; overlay.appendChild(lim);
    var prl = document.createElement('span'); prl.className = 'ln-ov-y ln-ov-pr'; prl.style.top = pct(PR_TOP - 4);
    prl.textContent = root.getAttribute('data-pulse-label') || 'Pulse'; overlay.appendChild(prl);
    var dot = document.createElement('i'); dot.className = 'ln-ov-dot'; overlay.appendChild(dot);
    var buzz = $('[data-ln-buzz]', root); if (buzz) overlay.appendChild(buzz);
    var flagWord = root.getAttribute('data-flag-label') || 'Vibration';
    var flags = events.map(function (ep) {
      var f = document.createElement('span'); f.className = 'ln-ov-flag';
      f.style.left = (xAt(ep.low) / 10).toFixed(2) + '%'; f.style.top = pct(yO2(N.o2[ep.low]) + 10);
      f.textContent = flagWord; overlay.appendChild(f); return f;
    });
    var clockEl = $('[data-ln-clock]', root), ampmEl = $('[data-ln-ampm]', root), roO2 = $('[data-ln-ro-o2]', root),
      roPR = $('[data-ln-ro-pr]', root), roState = $('[data-ln-ro-state]', root), steps = $$('[data-ln-step]', root);
    var states = (root.getAttribute('data-states') || 'Getting ready|Reading|Vibrating|Report ready').split('|');
    var lastStep = -1;
    function render(q) {
      q = clamp(q, 0, 1);
      var idx = Math.round(q * (n - 1)), m = idx * N.step, x = xAt(idx);
      clipRect.setAttribute('width', Math.max(0.01, x));
      head.setAttribute('x1', x); head.setAttribute('x2', x);
      dot.style.left = (x / 10) + '%'; dot.style.top = pct(yO2(N.o2[idx]));
      if (buzz) { buzz.style.left = clamp(x / 10, 6, 94) + '%'; buzz.style.top = pct(yO2(N.o2[idx])); }
      var c = N.clock(m);
      if (clockEl) clockEl.textContent = c.time;
      if (ampmEl) ampmEl.textContent = c.ampm;
      if (roO2) roO2.textContent = Math.round(N.o2[idx]) + '%';
      if (roPR) roPR.textContent = N.pr[idx];
      var alerting = N.o2[idx] < limit;
      var firstAlert = events.length ? events[0].start - 4 : Infinity;
      if (roState) {
        roState.textContent = q >= 0.985 ? states[3] : alerting ? states[2] : m < 24 ? states[0] : states[1];
        roState.classList.toggle('is-alert', alerting);
      }
      if (buzz) buzz.classList.toggle('is-on', alerting && !still);
      flags.forEach(function (f, k) { f.classList.toggle('is-on', idx >= events[k].low); });
      eventLines.forEach(function (l, k) { l.style.opacity = idx >= events[k].low ? '' : '0'; });
      var s = m < 70 ? 0 : (q >= 0.93 ? 3 : (idx >= firstAlert ? 2 : 1));
      if (s !== lastStep) { steps.forEach(function (st, k) { st.classList.toggle('is-active', k === s); }); lastStep = s; }
    }
    // The chart can also be read by hand: move across it (or drag on a phone), or use the arrow keys.
    var plot = $('[data-ln-scrub]', root), scrollQ = 0, curQ = 0, manual = false, dragging = false;
    function show(q) {
      curQ = clamp(q, 0, 1);
      render(curQ);
      if (plot) {
        var idx = Math.round(curQ * (n - 1)), c = N.clock(idx * N.step);
        plot.setAttribute('aria-valuenow', String(Math.round(curQ * 100)));
        plot.setAttribute('aria-valuetext', c.time + ' ' + c.ampm + ', ' + Math.round(N.o2[idx]) + '% oxygen, pulse ' + N.pr[idx]);
      }
    }
    if (plot) {
      var at = function (e) { var r = (plot.querySelector('svg') || plot).getBoundingClientRect(); return clamp((e.clientX - r.left) / r.width, 0, 1); };
      plot.addEventListener('pointerdown', function (e) { dragging = true; manual = true; root.classList.add('is-scrubbing'); show(at(e)); });
      plot.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch' && !dragging) return; manual = true; root.classList.add('is-scrubbing'); show(at(e)); });
      window.addEventListener('pointerup', function () { dragging = false; });
      plot.addEventListener('pointerleave', function () { if (dragging) return; manual = false; root.classList.remove('is-scrubbing'); show(scrollQ); });
      plot.addEventListener('keydown', function (e) {
        var d = { ArrowRight: 0.02, ArrowUp: 0.02, ArrowLeft: -0.02, ArrowDown: -0.02, PageUp: 0.1, PageDown: -0.1, Home: -1, End: 1 }[e.key];
        if (d === undefined) return;
        e.preventDefault(); manual = true; show(curQ + d);
      });
      plot.addEventListener('blur', function () { manual = false; show(scrollQ); });
    }
    return {
      render: function (q) { scrollQ = clamp(q, 0, 1); show(scrollQ); },
      scroll: function (q) { q = clamp(q, 0, 1); if (Math.abs(q - scrollQ) > 0.001) { manual = false; root.classList.remove('is-scrubbing'); } scrollQ = q; if (!manual) show(q); },
      steps: steps
    };
  }

  /* ---------------------------------------------------------------- points on the product (hero) */
  function closeSpots() {
    $$('[data-ln-spot].is-open').forEach(function (s) { s.classList.remove('is-open'); var b = $('.ln-spot__dot', s); if (b) b.setAttribute('aria-expanded', 'false'); });
    $$('.has-spot').forEach(function (h) { h.classList.remove('has-spot'); });
  }
  /* an open note goes on the top layer of the page: above the other points, the readouts and phone beside the
     product, and (on phones, where the hero picture sits over the headline) the hero text */
  function liftSpot(s) { var h = s.closest('.ln-hero__product, .ln-studio'); if (h) h.classList.add('has-spot'); var st = s.closest('.ln-hero__stage'); if (st) st.classList.add('has-spot'); }
  /* keep an open note inside its stage (and the screen): shift it sideways if it would be cut off */
  function nudge(s) {
    var card = $('.ln-spot__card', s); if (!card) return;
    card.style.removeProperty('--nx'); card.style.removeProperty('--ny');
    var box = s.closest('.ln-studio, .ln-hero'), br = box ? box.getBoundingClientRect() : { left: 0, right: innerWidth };
    var lo = Math.max(br.left, 0) + 10, hi = Math.min(br.right, innerWidth) - 10, r = card.getBoundingClientRect(), dx = 0, dy = 0;
    if (r.right > hi) dx = hi - r.right;
    if (r.left + dx < lo) dx = lo - r.left;
    if (dx) card.style.setProperty('--nx', Math.round(dx) + 'px');
    /* the studio clips its contents, so a note near its top or bottom edge moves inside too (12 px covers the bob) */
    if (box && box.classList.contains('ln-studio')) {
      if (r.bottom > br.bottom - 12) dy = br.bottom - 12 - r.bottom;
      if (r.top + dy < br.top + 12) dy = br.top + 12 - r.top;
      if (dy) card.style.setProperty('--ny', Math.round(dy) + 'px');
    }
  }
  function buildSpots(root) {
    $$('[data-ln-spot]', root).forEach(function (s) {
      if (s.__spot) return; s.__spot = true;
      var btn = $('.ln-spot__dot', s);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !s.classList.contains('is-open');
        closeSpots();
        s.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
        if (open) { liftSpot(s); nudge(s); }
      });
      s.addEventListener('pointerenter', function () { nudge(s); });
      s.addEventListener('focusin', function () { nudge(s); });
    });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('[data-ln-spot]')) closeSpots(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSpots(); });

  /* ---------------------------------------------------------------- "Feel the alert" */
  function buildFeel(root) {
    $$('[data-ln-feel]', root).forEach(function (b) {
      if (b.__feel) return; b.__feel = true;
      b.addEventListener('click', function () {
        // each button has its own message line next to it (one on the photo for phones, one under the slider)
        var sec = b.closest('.ln'), media = sec && $('.ln-alert__media', sec), msg = b.nextElementSibling && b.nextElementSibling.hasAttribute('data-ln-feel-msg') ? b.nextElementSibling : sec && $('[data-ln-feel-msg]', sec);
        try { if (navigator.vibrate) navigator.vibrate([200, 120, 200, 120, 200]); } catch (e) {}
        if (media) { media.classList.remove('is-buzzing'); void media.offsetWidth; media.classList.add('is-buzzing'); setTimeout(function () { media.classList.remove('is-buzzing'); }, 1300); }
        b.classList.add('is-on'); setTimeout(function () { b.classList.remove('is-on'); }, 1300);
        if (msg) msg.textContent = b.getAttribute('data-note') || '';
      });
    });
  }

  /* ---------------------------------------------------------------- "What do you need?" (product lines) */
  function buildFinder(root) {
    $$('[data-ln-finder]', root).forEach(function (f) {
      if (f.__finder) return; f.__finder = true;
      var sec = f.closest('.ln'), tiles = $$('[data-ln-tile]', sec), status = $('[data-ln-finder-status]', f);
      f.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ln-need]'); if (!b) return;
        var need = b.getAttribute('data-ln-need'), match = null;
        $$('[data-ln-need]', f).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        tiles.forEach(function (t) {
          var on = need === 'all' || t.getAttribute('data-ln-tile') === need;
          t.classList.toggle('is-dim', !on); t.classList.toggle('is-match', on && need !== 'all');
          if (on && need !== 'all') match = t;
        });
        if (status) status.textContent = match && match.querySelector('h3') ? match.querySelector('h3').textContent : '';
        if (match) {
          var row = match.parentElement;
          if (row.scrollWidth > row.clientWidth + 4) row.scrollTo({ left: match.offsetLeft - (row.clientWidth - match.offsetWidth) / 2, behavior: still ? 'auto' : 'smooth' });
          else if (match.getBoundingClientRect().top > innerHeight * 0.8 || match.getBoundingClientRect().bottom < 0) match.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' });
        }
      });
    });
  }

  /* ---------------------------------------------------------------- drag the reviews row with a mouse */
  function buildDrag(root) {
    $$('[data-ln-quotes]', root).forEach(function (row) {
      if (row.__drag || !fine) return; row.__drag = true;
      var down = false, x0 = 0, s0 = 0, moved = false;
      row.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = row.scrollLeft; row.classList.add('is-grabbing'); });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; row.scrollLeft = s0 - dx; });
      window.addEventListener('pointerup', function () { down = false; row.classList.remove('is-grabbing'); });
      row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------------------------------------------------------------- the limit slider */
  function buildTryit(root) {
    var tsvg = $('[data-ln-tryit-svg]', root), range = $('[data-ln-limit]', root);
    if (!tsvg || !range || tsvg.__built) return;
    tsvg.__built = true;
    var out = $('[data-ln-limit-out]', root), res = $('[data-ln-limit-result]', root);
    var tpl = res ? (res.getAttribute('data-template') || 'At {limit}%, this night would bring {count} gentle {vibrations}.') : '';
    var one = res ? (res.getAttribute('data-one') || 'vibration') : '', many = res ? (res.getAttribute('data-many') || 'vibrations') : '';
    var min = Number(range.min), max = Number(range.max);
    var T_TOP = 6, T_BOT = 144, T_MAX = 99, T_MIN = 85, n = N.o2.length;
    function ty(v) { return T_TOP + (T_MAX - v) / (T_MAX - T_MIN) * (T_BOT - T_TOP); }
    var uid = 'ln' + Math.random().toString(36).slice(2, 7);
    var tdefs = el('defs', {}, tsvg);
    var tclip = el('clipPath', { id: uid + '-under' }, tdefs);
    var tclipRect = el('rect', { x: 0, y: ty(90), width: 600, height: 200 }, tclip);
    var tD = '';
    for (var j = 0; j < n; j++) tD += (j ? 'L' : 'M') + (j / (n - 1) * 600).toFixed(1) + ' ' + ty(N.o2[j]).toFixed(1);
    el('path', { d: tD + 'L600 0L0 0Z', class: 'ln-t-under', 'clip-path': 'url(#' + uid + '-under)' }, tsvg);
    el('path', { d: tD, class: 'ln-t-line' }, tsvg);
    var tLimit = el('line', { x1: 0, x2: 600, y1: ty(90), y2: ty(90), class: 'ln-t-limit' }, tsvg);
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function setLimit(v) {
      v = Number(v);
      var count = N.episodes(v).length;
      if (out) out.textContent = v + '%';
      range.style.setProperty('--p', ((v - min) / (max - min) * 100) + '%');
      range.setAttribute('aria-valuetext', v + '%');
      tLimit.setAttribute('y1', ty(v)); tLimit.setAttribute('y2', ty(v));
      tclipRect.setAttribute('y', ty(v));
      if (res) res.innerHTML = esc(tpl).replace('{limit}', v).replace('{count}', '<strong>' + count + '</strong>').replace('{vibrations}', esc(count === 1 ? one : many));
    }
    range.addEventListener('input', function () { setLimit(range.value); });
    setLimit(range.value);
  }

  /* ---------------------------------------------------------------- videos: play only while seen */
  function buildVideo(root) {
    var video = $('[data-ln-autovideo]', root), btn = $('[data-ln-vtoggle]', root);
    if (!video || video.__built) return;
    video.__built = true;
    var userPaused = still;
    function state() { if (!btn) return; var p = video.paused; btn.classList.toggle('is-paused', p); btn.setAttribute('aria-label', p ? btn.getAttribute('data-play') : btn.getAttribute('data-pause')); }
    if (btn) btn.addEventListener('click', function () { if (video.paused) { userPaused = false; video.play(); } else { userPaused = true; video.pause(); } });
    video.addEventListener('play', state); video.addEventListener('pause', state); state();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !userPaused) {
            if (!video.src && video.getAttribute('data-src')) video.src = video.getAttribute('data-src');
            video.play().catch(function () {});
          } else if (!e.isIntersecting) video.pause();
        });
      }, { threshold: 0.35 }).observe(video);
    }
  }

  /* ---------------------------------------------------------------- pointer light on cards and tiles */
  function buildPointer(root) {
    $$('[data-ln-glow]', root).forEach(function (card) {
      if (card.__glow) return; card.__glow = true;
      card.addEventListener('pointermove', function (e) { var r = card.getBoundingClientRect(); card.style.setProperty('--mx', (e.clientX - r.left) + 'px'); card.style.setProperty('--my', (e.clientY - r.top) + 'px'); });
    });
  }

  /* ---------------------------------------------------------------- reviews row buttons */
  function buildQuotes(root) {
    var row = $('[data-ln-quotes]', root);
    if (!row || row.__built) return; row.__built = true;
    function stepBy(dir) { var card = row.querySelector('.ln-quote'); var w = card ? card.getBoundingClientRect().width + 20 : 400; row.scrollBy({ left: dir * w, behavior: still ? 'auto' : 'smooth' }); }
    var prev = $('[data-ln-quotes-prev]', root), next = $('[data-ln-quotes-next]', root);
    if (prev) prev.addEventListener('click', function () { stepBy(-1); });
    if (next) next.addEventListener('click', function () { stepBy(1); });
  }

  /* ---------------------------------------------------------------- light rays (Animmaster bg-1, LOOKEE® tint) */
  function Rays(container, opts) {
    opts = opts || {};
    var hex = (opts.color || '#ffb48c').replace('#', '');
    var color = [parseInt(hex.slice(0, 2), 16) / 255, parseInt(hex.slice(2, 4), 16) / 255, parseInt(hex.slice(4, 6), 16) / 255];
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'width:100%;height:100%;display:block';
    container.appendChild(canvas);
    var gl = canvas.getContext('webgl', { alpha: true, antialias: false, premultipliedAlpha: false });
    if (!gl) return null;
    var vert = 'attribute vec2 position;void main(){gl_Position=vec4(position,0.0,1.0);}';
    var frag = ['precision highp float;',
      'uniform float iTime;uniform vec2 iResolution;uniform vec2 rayPos;uniform vec2 rayDir;uniform vec3 raysColor;',
      'uniform float raysSpeed;uniform float lightSpread;uniform float rayLength;uniform vec2 mousePos;uniform float mouseInfluence;uniform float noiseAmount;uniform float distortion;',
      'float noise(vec2 st){return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123);}',
      'float rayStrength(vec2 src,vec2 dir,vec2 coord,float a,float b,float speed){',
      ' vec2 sc=coord-src;vec2 dn=normalize(sc);float ca=dot(dn,dir);',
      ' float da=ca+distortion*sin(iTime*2.0+length(sc)*0.01)*0.2;',
      ' float spread=pow(max(da,0.0),1.0/max(lightSpread,0.001));',
      ' float dist=length(sc);float maxD=iResolution.x*rayLength;',
      ' float lf=clamp((maxD-dist)/maxD,0.0,1.0);',
      ' float base=clamp((0.45+0.15*sin(da*a+iTime*speed))+(0.3+0.2*cos(-da*b+iTime*speed)),0.0,1.0);',
      ' return base*lf*spread;}',
      'void main(){',
      ' vec2 coord=vec2(gl_FragCoord.x,iResolution.y-gl_FragCoord.y);',
      ' vec2 md=normalize(mousePos*iResolution.xy-rayPos);vec2 dir=normalize(mix(rayDir,md,mouseInfluence));',
      ' vec4 c=vec4(1.0)*rayStrength(rayPos,dir,coord,36.2214,21.11349,1.5*raysSpeed)*0.5+vec4(1.0)*rayStrength(rayPos,dir,coord,22.3991,18.0234,1.1*raysSpeed)*0.4;',
      ' float n=noise(coord*0.01+iTime*0.1);c.rgb*=(1.0-noiseAmount+noiseAmount*n);',
      ' float br=1.0-(coord.y/iResolution.y);c.rgb*=0.15+br*0.85;',
      ' c.rgb*=raysColor;c.a=max(max(c.r,c.g),c.b);gl_FragColor=c;}'].join('\n');
    function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; }
    var vs = sh(gl.VERTEX_SHADER, vert), fs = sh(gl.FRAGMENT_SHADER, frag);
    if (!vs || !fs) return null;
    var prog = gl.createProgram(); gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
    gl.useProgram(prog);
    gl.enable(gl.BLEND); gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'position'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    function U(nm) { return gl.getUniformLocation(prog, nm); }
    var u = { t: U('iTime'), res: U('iResolution'), pos: U('rayPos'), dir: U('rayDir'), col: U('raysColor'), spd: U('raysSpeed'), spr: U('lightSpread'), len: U('rayLength'), mouse: U('mousePos'), mi: U('mouseInfluence'), noise: U('noiseAmount'), dis: U('distortion') };
    gl.uniform3fv(u.col, color); gl.uniform1f(u.spd, opts.speed || 0.6); gl.uniform1f(u.spr, opts.spread || 0.9);
    gl.uniform1f(u.len, opts.length || 1.4); gl.uniform1f(u.mi, 0.08); gl.uniform1f(u.noise, 0.08); gl.uniform1f(u.dis, 0.04);
    var mouse = [0.5, 0.3], smooth = [0.5, 0.3], raf = 0, running = false;
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var w = Math.max(1, Math.floor(container.clientWidth * dpr)), h = Math.max(1, Math.floor(container.clientHeight * dpr));
      canvas.width = w; canvas.height = h; gl.viewport(0, 0, w, h);
      gl.uniform2f(u.res, w, h); gl.uniform2f(u.pos, w * 0.56, -0.25 * h); gl.uniform2f(u.dir, 0, 1);
    }
    function loop(t) {
      smooth[0] += (mouse[0] - smooth[0]) * 0.05; smooth[1] += (mouse[1] - smooth[1]) * 0.05;
      gl.uniform1f(u.t, t * 0.001); gl.uniform2f(u.mouse, smooth[0], smooth[1]);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); gl.drawArrays(gl.TRIANGLES, 0, 3);
      raf = running ? requestAnimationFrame(loop) : 0;
    }
    size();
    window.addEventListener('resize', size);
    window.addEventListener('pointermove', function (e) { var r = container.getBoundingClientRect(); mouse = [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; }, { passive: true });
    return { start: function () { if (!running) { running = true; raf = requestAnimationFrame(loop); } }, stop: function () { running = false; cancelAnimationFrame(raf); } };
  }


  /* ---------------------------------------------------------------- product spotlights: the studio
     The real product on a white stage. It floats and leans toward the pointer; the glowing points open notes on
     its features and take turns while nobody touches the stage. The buttons under the stage change the view
     behind opening blinds (HealGlow(TM) Pro: the panel, near-infrared, in use; the App stage: asleep, an alert,
     the morning report). HealGlow(TM) Pro: the lights sweep on the first time the panel is seen. A8: pulses roll
     out from both grips in the rhythm of each mode, stronger with each level, and the meter fills.
     Reduced motion: no float, tilt, sweep or blinds; every button still changes the view. */
  function blinds(scene, done) {
    if (still) { done(); return; }
    scene.classList.add('is-in');
    var t0 = performance.now(), dur = 1000;
    (function step(now) {
      var q = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - q, 3);
      scene.style.setProperty('--o', e.toFixed(4));
      if (q < 1) requestAnimationFrame(step);
      else { scene.classList.remove('is-in'); scene.style.removeProperty('--o'); done(); }
    })(t0);
  }
  function buildStudio(sec) {
    var st = $('[data-ln-studio]', sec);
    if (!st || st.__studio) return; st.__studio = true;
    var kind = st.getAttribute('data-ln-studio'), stage = st.closest('.ln-spot-sec__stage') || st;
    var scenes = $$('[data-ln-scene]', st), btns = $$('[data-ln-scene-btn]', sec), cap = $('[data-ln-scene-caption]', sec);
    var spots = $$('[data-ln-spot]', st), obj = $('[data-ln-studio-tilt]', st);
    var cur = 0, inView = false, touched = false, timer = 0, spotI = -1, busy = false, lit = false;
    var STATES = ['live', 'alert', 'report'];
    function byN(list, attr, n) { return list.filter(function (x) { return +x.getAttribute(attr) === n; })[0]; }

    function playVideos() {
      scenes.forEach(function (s) {
        var v = $('video', s); if (!v) return;
        if (+s.getAttribute('data-ln-scene') === cur && inView && !still) v.play().catch(function () {}); else v.pause();
      });
    }
    function setState(n) {
      st.setAttribute('data-state', STATES[n] || 'live');
      $$('[data-ln-screen]', st).forEach(function (img) { img.classList.toggle('is-on', img.getAttribute('data-ln-screen') === (n === 2 ? 'report' : 'live')); });
    }
    function show(n) {
      if (busy) return;
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-ln-scene-btn') === n)); });
      var b = byN(btns, 'data-ln-scene-btn', n);
      if (cap && b && b.getAttribute('data-caption')) cap.innerHTML = b.getAttribute('data-caption');
      if (n === cur) return;
      closeSpots();
      if (kind === 'app') { cur = n; setState(n); return; }
      var next = byN(scenes, 'data-ln-scene', n), prev = byN(scenes, 'data-ln-scene', cur);
      cur = n;
      if (!next) return;
      busy = true; playVideos();
      blinds(next, function () { if (prev) prev.classList.remove('is-on'); next.classList.add('is-on'); busy = false; playVideos(); });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { stop(true); show(+b.getAttribute('data-ln-scene-btn')); }); });
    if (kind === 'app') setState(0);

    /* HealGlow(TM) Pro: the lights come on, left to right, with the red bloom */
    function powerOn() {
      if (kind !== 'light' || lit) return; lit = true;
      if (still) { st.style.removeProperty('--lit'); return; }
      var t0 = performance.now(), dur = 2200;
      (function step(now) {
        var q = Math.min(1, (now - t0) / dur), e = q < 0.5 ? 4 * q * q * q : 1 - Math.pow(-2 * q + 2, 3) / 2;
        st.style.setProperty('--lit', e.toFixed(4));
        if (q < 1) requestAnimationFrame(step);
      })(t0);
    }
    if (kind === 'light' && !still) st.style.setProperty('--lit', '0');

    /* A8: pulses in the rhythm of the mode; the level sets their reach and strength */
    var emits = $$('[data-ln-emit]', st), meter = $$('.ln-meter i', st), mode = 0, level = 1, beat = 0, ptimer = 0, setLevel = null, lmax = 15, stepN = 1;
    function pulse(side, k) {
      var e = emits[side]; if (!e) return;
      var i = document.createElement('i'), lv = (level - 1) / 14;
      i.style.setProperty('--s', (1.6 + lv * 1.8 * k).toFixed(2));
      i.style.setProperty('--a', (0.4 + lv * 0.55).toFixed(2));
      i.style.setProperty('--d', (1.55 - lv * 0.45).toFixed(2) + 's');
      e.appendChild(i); setTimeout(function () { if (i.parentNode) i.parentNode.removeChild(i); }, 1700);
    }
    function pulses() {
      ptimer = 0;
      if (!inView || still || !emits.length) return;
      var m = mode === 4 ? Math.floor(performance.now() / 3000) % 4 : mode, delay;
      if (m === 0) { pulse(beat % 2, 1.15); delay = 760; }                              // kneading: slow, side to side
      else if (m === 1) { pulse(0, 0.6); pulse(1, 0.6); delay = 270; }                  // tapping: quick and light
      else if (m === 2) { pulse(0, 0.85); pulse(1, 0.85); delay = beat % 3 === 2 ? 860 : 130; } // cupping: bursts of three
      else { pulse(beat % 2, 0.9); delay = 380; }                                       // scraping: fast, side to side
      beat++;
      ptimer = setTimeout(pulses, delay);
    }
    if (kind === 'ems') {
      var modeBtns = $$('[data-ln-mode]', sec);
      var setMode = function (n) { mode = n; beat = 0; modeBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(+x.getAttribute('data-ln-mode') === n)); }); };
      modeBtns.forEach(function (b) { b.addEventListener('click', function () { stop(true); setMode(+b.getAttribute('data-ln-mode')); }); });
      // any number of levels (A8: 15, TENS: 40) shows on the same 15-bar meter
      var lout = $('[data-ln-stepper-out]', sec);
      lmax = Math.max(2, +(lout && lout.getAttribute('data-max')) || 15);
      setLevel = stepper(sec, 1, lmax, function (n) {
        stepN = n;
        level = 1 + (n - 1) / (lmax - 1) * 14;
        var bars = Math.round(level);
        meter.forEach(function (b, k) { b.classList.toggle('is-on', k < bars); });
        st.style.setProperty('--lvl', (0.15 + (level - 1) / 14 * 0.85).toFixed(3));
      });
      $$('[data-ln-stepper]', sec).forEach(function (b) { b.addEventListener('click', function () { stop(true); }); });
    }

    /* while watched and untouched: the points take turns, then the next view (A8: modes and levels step up) */
    var tick = 0;
    /* on phones a note opens only when tapped: it would cover half the product */
    var tapOnly = !!(window.matchMedia && matchMedia('(hover: none)').matches);
    function step() {
      if (!inView || touched) return;
      tick++;
      if (kind === 'ems') {
        if (spots.length && !tapOnly) { spotI = (spotI + 1) % spots.length; openSpot(spots[spotI]); }
        if (setLevel && tick % 2 === 0) { var jump = Math.max(1, Math.round(lmax / 7)); setLevel(stepN + jump > Math.round(lmax * 0.75) ? 1 + jump : stepN + jump); }
        if (tick % 3 === 0) { var mb = $$('[data-ln-mode]', sec); var nm = (mode + 1) % Math.max(1, mb.length); mode = nm; beat = 0; mb.forEach(function (x) { x.setAttribute('aria-pressed', String(+x.getAttribute('data-ln-mode') === nm)); }); }
        return;
      }
      if (!tapOnly && cur === 0 && spots.length && spotI < spots.length - 1) { spotI++; openSpot(spots[spotI]); return; }
      if (btns.length > 1) { spotI = -1; show((cur + 1) % btns.length); }
    }
    function openSpot(s) { closeSpots(); s.classList.add('is-open'); liftSpot(s); var d = $('.ln-spot__dot', s); if (d) d.setAttribute('aria-expanded', 'true'); nudge(s); }
    function start() { if (still || touched || timer) return; timer = setInterval(step, 3400); }
    function stop(byUser) { if (byUser) touched = true; clearInterval(timer); timer = 0; }
    stage.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('[data-ln-spot]')) stop(true); });
    stage.addEventListener('keydown', function () { stop(true); });

    /* the product leans toward the pointer */
    if (fine && !still && obj) {
      var tx = 0, ty = 0, cx = 0, cy = 0, traf = 0;
      var tilt = function () {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        obj.style.transform = 'perspective(1100px) rotateY(' + (cx * 16).toFixed(2) + 'deg) rotateX(' + (-cy * 11).toFixed(2) + 'deg)';
        traf = (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) ? requestAnimationFrame(tilt) : 0;
      };
      st.addEventListener('pointermove', function (e) { var r = st.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width - 0.5; ty = (e.clientY - r.top) / r.height - 0.5; if (!traf) traf = requestAnimationFrame(tilt); });
      st.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!traf) traf = requestAnimationFrame(tilt); });
    }

    function onView(v) {
      inView = v;
      if (v) { powerOn(); start(); if (!ptimer && kind === 'ems') pulses(); }
      else stop(false);
      playVideos();
    }
    if (still || !('IntersectionObserver' in window)) { if (kind === 'light') powerOn(); return; }
    new IntersectionObserver(function (es) { onView(es[0].isIntersecting); }, { threshold: 0.4 }).observe(st);
  }

  /* +/- control shared by the A8 levels (returns a setter, so the demo can step it too) */
  function stepper(sec, min, max, onChange) {
    var out = $('[data-ln-stepper-out]', sec); if (!out) return null;
    var word = out.getAttribute('data-word') || '', n = min, btns = $$('[data-ln-stepper]', sec);
    function set(v) {
      n = clamp(v, min, max); out.textContent = word + ' ' + n;
      btns.forEach(function (b) { b.disabled = (+b.getAttribute('data-ln-stepper') < 0 && n === min) || (+b.getAttribute('data-ln-stepper') > 0 && n === max); });
      onChange(n);
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { set(n + (+b.getAttribute('data-ln-stepper'))); }); });
    set(min);
    return set;
  }

  /* ---------------------------------------------------------------- the product wall: a pull-back reveal
     The section is about 2.8 screens tall; its content stays put (position: sticky) while you scroll through it.
     Scroll progress p (0 to 1) drives everything, smoothed so it glides even with a notched mouse wheel:
     the LOOKEE® banner shrinks from most of the screen into the centre tile (its small print fades as it gets
     too small to read), the tiles arrive nearest first and each can be clicked as soon as it is mostly there,
     and the caption rises last. If the finished wall is taller than the screen, the whole scene is scaled to fit.
     Wide screens with motion on only; elsewhere the banner sits on top of the grid. */
  function buildWall(sec) {
    if (sec.__wall) return; sec.__wall = true;
    var track = $('.ln-wall__track', sec), sticky = $('.ln-wall__sticky', sec), scene = $('[data-ln-wall-scene]', sec), grid = $('[data-ln-wall-grid]', sec);
    var center = $('[data-ln-wall-center]', sec), banner = $('[data-ln-banner]', sec), tiles = $$('[data-ln-wall-tile]', sec), cap = $('[data-ln-wall-caption]', sec);
    if (!track || !sticky || !scene) return;
    if (banner) {
      if (still || !('IntersectionObserver' in window)) banner.classList.add('is-on');
      else { var bio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { banner.classList.add('is-on'); bio.disconnect(); } }, { threshold: 0.25 }); bio.observe(banner); }
    }
    var wide = window.matchMedia('(min-width: 1200px) and (min-height: 680px)'), on = false, cur = 0, target = 0, raf = 0;
    var S0 = 1, dx0 = 0, dy0 = 0, f = 1, k = 0.22;
    function ease(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
    function fit() {
      // the scene sits just under the sticky site header, whatever its height
      var hd = $('.header'); if (hd) sec.style.setProperty('--ln-top', Math.round(hd.getBoundingClientRect().height) + 'px');
      if (!center || !banner) return;
      if (on) {
        // Rows fill the screen: three rows share the height left under the header (minus the caption), at most
        // as tall as a tile is wide. The banner (laid out at 1000 px or wider) is scaled to fill its tile.
        banner.style.width = ''; banner.style.height = '';
        var colW = center.clientWidth, natH = Math.max(1, banner.offsetHeight);
        var gap = grid ? parseFloat(getComputedStyle(grid).rowGap) || 14 : 14;
        var capH = cap ? cap.offsetHeight : 0;
        var avail = (sticky.clientHeight - 24 - capH - 2 * gap) / 3;
        var h = Math.round(Math.max(150, Math.min(avail, colW * 0.95)));
        if (h / natH >= colW / 1000) { k = colW / 1000; }
        else { k = h / natH; banner.style.width = Math.round(colW / k) + 'px'; }
        banner.style.height = Math.round(h / k) + 'px';
        banner.style.setProperty('--k', k.toFixed(4));
        center.style.height = h + 'px';
        if (grid) grid.style.setProperty('--row', h + 'px');
      } else {
        banner.style.removeProperty('--k'); banner.style.removeProperty('--more'); center.style.height = '';
        banner.style.width = ''; banner.style.height = '';
        if (grid) grid.style.removeProperty('--row');
      }
    }
    function measure() {
      if (!on || !center) return;
      center.style.transform = 'none'; scene.style.transform = 'none';
      f = Math.min(1, (sticky.clientHeight - 16) / Math.max(1, scene.offsetHeight));
      scene.style.transform = 'scale(' + f.toFixed(4) + ')';
      var sr = sticky.getBoundingClientRect(), cr = center.getBoundingClientRect();
      S0 = Math.max(1, Math.min(0.9 * sr.width / cr.width, 0.86 * sr.height / cr.height));
      dx0 = (sr.left + sr.width / 2 - (cr.left + cr.width / 2)) / f;
      dy0 = (sr.top + sr.height / 2 - (cr.top + cr.height / 2)) / f;
      apply(cur);
    }
    function apply(p) {
      if (!on) return;
      var e = ease(clamp(p / 0.55, 0, 1)), s = S0 + (1 - S0) * e;
      if (center) center.style.transform = 'translate3d(' + (dx0 * (1 - e)).toFixed(1) + 'px,' + (dy0 * (1 - e)).toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ')';
      if (banner) banner.style.setProperty('--more', clamp((k * f * s - 0.5) / 0.16, 0, 1).toFixed(3));
      var n = [0, 0, 0];
      tiles.forEach(function (t) {
        var ring = clamp(+t.getAttribute('data-ring') || 1, 1, 2), i = n[ring]++;
        var start = (ring === 1 ? 0.3 : 0.44) + i * 0.028, q = clamp((p - start) / 0.2, 0, 1);
        t.style.opacity = q.toFixed(3);
        t.style.transform = 'translate3d(0,' + (40 * (1 - q)).toFixed(1) + 'px,0)';
        t.style.pointerEvents = q > 0.55 ? '' : 'none';
      });
      if (cap) {
        var qc = clamp((p - 0.74) / 0.18, 0, 1);
        cap.style.opacity = qc.toFixed(3); cap.style.transform = 'translate3d(0,' + (30 * (1 - qc)).toFixed(1) + 'px,0)';
        cap.style.pointerEvents = qc > 0.5 ? '' : 'none';
      }
    }
    // 0 when the scene starts to stick under the header, 1 just before it lets go
    function progress() {
      var r = track.getBoundingClientRect(), total = track.offsetHeight - sticky.offsetHeight, top = parseFloat(getComputedStyle(sec).getPropertyValue('--ln-top')) || 0;
      return clamp((top - r.top) / Math.max(1, total), 0, 1);
    }
    function tick() {
      cur += (target - cur) * 0.2;
      if (Math.abs(target - cur) < 0.0008) cur = target;
      apply(cur);
      raf = cur !== target ? requestAnimationFrame(tick) : 0;
    }
    function onScroll() { if (!on) return; target = progress(); if (!raf) raf = requestAnimationFrame(tick); }
    function setMode() {
      on = !still && wide.matches && !design;
      sec.classList.toggle('ln-wall--scene', on); sec.classList.toggle('ln-wall--static', !on);
      if (!on) {
        if (center) center.style.transform = '';
        scene.style.transform = '';
        tiles.forEach(function (t) { t.style.opacity = ''; t.style.transform = ''; t.style.pointerEvents = ''; });
        if (cap) { cap.style.opacity = ''; cap.style.transform = ''; cap.style.pointerEvents = ''; }
      }
      fit(); cur = target = on ? progress() : 1; measure();
    }
    setMode();
    if (wide.addEventListener) wide.addEventListener('change', setMode);
    window.addEventListener('resize', function () { fit(); measure(); });
    window.addEventListener('scroll', onScroll, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(); measure(); });
    $$('img', sec).forEach(function (im) { if (!im.complete) im.addEventListener('load', function () { if (on) { fit(); measure(); } }, { once: true }); });
    sec.__wallMode = setMode;
  }

  /* ---------------------------------------------------------------- the header over the night */
  function headerWatch() {
    var head = $('.header--night');
    if (!head) return;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      head.classList.toggle('is-solid', y > 30);
      var r = head.getBoundingClientRect(), probe = r.bottom + 2, day = false;
      var hit = document.elementFromPoint(Math.round(window.innerWidth / 2), Math.round(probe));
      var sec = hit && hit.closest ? hit.closest('.ln, .shopify-section, footer') : null;
      if (sec && sec.classList.contains('ln')) {
        if (sec.classList.contains('ln-light')) day = true;
        else if (sec.hasAttribute('data-ln-dawn')) { var d = sec.getBoundingClientRect(); var paper = window.innerWidth <= 760 ? 1200 : d.height * 0.64; day = probe - d.top >= paper; }
      } else if (sec && !(sec.querySelector && (sec.querySelector('.footer') || sec.tagName === 'FOOTER'))) {
        day = !!(hit && !hit.closest('.footer, .chapter--night'));
      }
      head.classList.toggle('is-day', day);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------------------------------------------------------------- build every section (all modes) */
  var nights = [];
  function buildAll(root) {
    root = root || document;
    $$('[data-ln-night]', root).forEach(function (sec) { var c = buildNight(sec); if (c) { nights.push({ el: sec, chart: c }); if (still) { c.render(1); c.steps.forEach(function (s) { s.classList.add('is-active'); }); } } });
    $$('[data-ln-tryit]', root).forEach(buildTryit);
    var each = function (sec) { buildVideo(sec); buildPointer(sec); buildQuotes(sec); buildSpots(sec); buildFeel(sec); buildFinder(sec); buildDrag(sec); buildStudio(sec); if (sec.hasAttribute && sec.hasAttribute('data-ln-wall')) buildWall(sec); };
    $$('.ln', root).forEach(each);
    if (root.classList && root.classList.contains('ln')) each(root);
    if (still) $$('[data-ln-hero-trace]', root).forEach(function (c) { c.style.display = 'none'; });
  }

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    buildAll(document);
    headerWatch();
    document.addEventListener('shopify:section:load', function (e) { buildAll(e.target); });
    if (still) return;
    loadLibs(function (ok) { if (!ok || !window.gsap || !window.ScrollTrigger) { goStill(); nights.forEach(function (n) { n.chart.render(1); n.chart.steps.forEach(function (s) { s.classList.add('is-active'); }); }); return; } motion(); });
  });

  // All libraries are requested at once (they download side by side); async = false keeps them running in order.
  function loadLibs(done) {
    var left = 0, over = false, timer = setTimeout(function () { finish(false); }, 8000);
    function finish(ok) { if (over) return; over = true; clearTimeout(timer); done(ok); }
    function settle() { if (--left === 0) finish(true); }
    LIBS.forEach(function (url) {
      if (document.querySelector('script[src="' + url + '"]')) return;
      left++;
      var s = document.createElement('script'); s.src = url; s.async = false;
      s.onload = settle;
      s.onerror = function () { if (url.indexOf('lenis') > -1) settle(); else finish(false); };
      document.head.appendChild(s);
    });
    if (!left) finish(true);
  }

  /* ================================================================ motion */
  function motion() {
    window.__lnReady = true;
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger, SplitText = window.SplitText;
    gsap.registerPlugin(ScrollTrigger);
    if (SplitText) gsap.registerPlugin(SplitText);
    var lenis = null;
    // Smooth scrolling belongs to the homepage; product and other pages that reuse a section keep normal scrolling.
    if (window.Lenis && document.body.classList.contains('ln-page')) {
      lenis = new window.Lenis({ lerp: 0.1, wheelMultiplier: 0.95 });
      window.__lnLenis = lenis;
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
      // Dialogs scroll on their own: pause the smooth scroll while the menu, cart or search is open.
      $$('[data-menu], [data-drawer], [data-search-panel], .lightbox, .search-panel').forEach(function (d) { d.setAttribute('data-lenis-prevent', ''); });
      var lock = function () { var open = $$('[data-menu], [data-drawer], [data-lightbox]').some(function (d) { return !d.hidden; }) || document.body.style.overflow === 'hidden'; open ? lenis.stop() : lenis.start(); };
      new MutationObserver(lock).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['hidden', 'style'] });
    }
    $$('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href'); if (id.length < 2) return;
        var t = document.getElementById(id.slice(1)); if (!t) return;
        e.preventDefault();
        if (lenis) lenis.scrollTo(t, { offset: -70, duration: 1.6 }); else t.scrollIntoView({ behavior: 'smooth' });
      });
    });

    /* The first screen is already showing: only the light rays fade in behind it. */
    var hero = $('.ln-hero');
    html.classList.add('ln-loaded');
    if (hero) gsap.fromTo('[data-ln-rays]', { opacity: 0 }, { opacity: 0.75, duration: 2.4, ease: 'power1.out' });

    /* Hero: rays, live trace, product tilt, scroll away */
    if (hero) {
      var raysBox = $('[data-ln-rays]', hero), rays = raysBox ? Rays(raysBox, { color: '#ff8a4a', speed: 0.5, spread: 0.9, length: 1.4 }) : null;
      var tc = $('[data-ln-hero-trace]', hero), tctx = tc ? tc.getContext('2d') : null, tw = 0, th = 0, toff = 0;
      var traceSize = function () { if (!tc) return; var dpr = Math.min(window.devicePixelRatio || 1, 2); tw = tc.clientWidth; th = tc.clientHeight; tc.width = tw * dpr; tc.height = th * dpr; tctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
      var traceY = function (x) {
        var t = x * 0.012, v = Math.sin(t) * 1.4 + Math.sin(t * 2.7 + 1.3) * 0.8 + Math.sin(t * 7.1) * 0.35, p = ((x % 900) + 900) % 900;
        v -= 22 * Math.exp(-Math.pow((p - 610) / 26, 2)); v += 7 * Math.exp(-Math.pow((p - 660) / 18, 2));
        return th * 0.5 - v * 1.6;
      };
      var drawTrace = function () {
        if (!tctx) return;
        tctx.clearRect(0, 0, tw, th);
        var gr = tctx.createLinearGradient(0, 0, tw, 0);
        gr.addColorStop(0, 'rgba(254,80,0,0)'); gr.addColorStop(0.18, 'rgba(254,80,0,.55)'); gr.addColorStop(0.62, 'rgba(255,110,40,1)'); gr.addColorStop(0.86, 'rgba(254,80,0,.4)'); gr.addColorStop(1, 'rgba(254,80,0,0)');
        tctx.beginPath();
        for (var x = 0; x <= tw; x += 3) { var y = traceY(x + toff); if (x) tctx.lineTo(x, y); else tctx.moveTo(x, y); }
        tctx.strokeStyle = gr; tctx.lineWidth = 2.2; tctx.shadowColor = 'rgba(254,80,0,.9)'; tctx.shadowBlur = 14; tctx.stroke();
        tctx.shadowBlur = 0; tctx.lineWidth = 0.8; tctx.strokeStyle = 'rgba(255,220,200,.5)'; tctx.stroke();
      };
      traceSize(); window.addEventListener('resize', traceSize);
      var prod = $('[data-ln-tilt]', hero), tx = 0, ty = 0, cx = 0, cy = 0, heroOn = true;
      if (fine) window.addEventListener('pointermove', function (e) { tx = e.clientX / innerWidth - 0.5; ty = e.clientY / innerHeight - 0.5; }, { passive: true });
      var frame = 0;
      gsap.ticker.add(function () {
        if (!heroOn) return;
        // the trace redraws at 30 fps (it moves slowly), the tilt only follows a mouse
        if (++frame % 2) { toff += 1.8; drawTrace(); }
        if (!fine) return;
        cx += (tx - cx) * 0.05; cy += (ty - cy) * 0.05;
        if (prod) prod.style.transform = 'rotateY(' + (cx * 18).toFixed(2) + 'deg) rotateX(' + (-cy * 12).toFixed(2) + 'deg) translate3d(' + (cx * 24).toFixed(1) + 'px,' + (cy * 16).toFixed(1) + 'px,0)';
      });
      ScrollTrigger.create({ trigger: hero, start: 'top bottom', end: 'bottom top', onToggle: function (self) { heroOn = self.isActive; if (rays) { if (self.isActive) rays.start(); else rays.stop(); } } });
      if (rays) rays.start();
      gsap.matchMedia().add('(min-width: 1000px)', function () {
        gsap.to('.ln-hero__copy', { yPercent: -22, opacity: 0, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom 20%', scrub: true } });
        gsap.to('.ln-hero__stage', { yPercent: 12, scale: 0.9, opacity: 0.2, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        gsap.to('.ln-hero__trace', { yPercent: -60, opacity: 0, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom 30%', scrub: true } });
      });
    }

    /* Magnetic buttons */
    if (fine) $$('[data-ln-magnetic]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); gsap.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.22, y: (e.clientY - r.top - r.height / 2) * 0.3, duration: 0.5, ease: 'power3.out' }); });
      b.addEventListener('pointerleave', function () { gsap.to(b, { x: 0, y: 0, duration: 0.8, ease: 'elastic.out(1, .4)' }); });
    });

    /* Headings rise line by line; blocks fade up */
    if (SplitText) $$('[data-ln-split]').forEach(function (h) {
      SplitText.create(h, { type: 'lines,words', mask: 'lines', linesClass: 'ln-split-line', autoSplit: true,
        onSplit: function (self) { return gsap.from(self.lines, { yPercent: 110, duration: 1.2, ease: 'expo.out', stagger: 0.1, scrollTrigger: { trigger: h, start: 'top 86%', once: true } }); } });
    });
    ScrollTrigger.batch('[data-ln-reveal]', { start: 'top 88%', once: true, onEnter: function (b) { gsap.to(b, { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out', stagger: 0.1 }); } });

    /* The range tiles rise */
    // Watched with an IntersectionObserver, not a ScrollTrigger: the pinned scenes above change the page's height
    // after load, which made a scroll trigger fire late and left the tiles empty for a long moment.
    $$('[data-ln-tiles]').forEach(function (t) {
      var kids = t.children;
      if (!('IntersectionObserver' in window)) return;
      gsap.set(kids, { y: 40, opacity: 0 });
      var io = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        gsap.to(kids, { y: 0, opacity: 1, duration: 0.7, ease: 'expo.out', stagger: 0.06, overwrite: true });
      }, { rootMargin: '0px 0px -8% 0px' });
      io.observe(t);
    });

    /* Manifesto: words light up, photos open in the sentence */
    $$('[data-ln-manifesto]').forEach(function (man) {
      if (SplitText) SplitText.create(man, { type: 'words', wordsClass: 'ln-word' });
      var items = $$('.ln-word, .ln-slot', man), slots = $$('.ln-slot', man);
      gsap.set(slots, { scale: 0.2, opacity: 0 });
      var mtl = gsap.timeline({ scrollTrigger: { trigger: man, start: 'top 78%', end: 'bottom 42%', scrub: 0.6 } });
      items.forEach(function (it, k) { var isSlot = it.classList.contains('ln-slot'); mtl.to(it, { opacity: 1, scale: 1, duration: isSlot ? 1.6 : 0.6, ease: isSlot ? 'back.out(1.8)' : 'none' }, k * 0.32); });
    });

    /* One night, pinned to the scroll (the pointer or the arrow keys can still read any moment) */
    nights.forEach(function (nt) {
      nt.chart.render(0);
      ScrollTrigger.create({ trigger: $('[data-ln-night-pin]', nt.el), start: 'top top', end: function () { return '+=' + Math.round(innerHeight * (innerWidth < 1000 ? 2.6 : 3.4)); },
        pin: true, scrub: true, anticipatePin: 1, invalidateOnRefresh: true, onUpdate: function (self) { nt.chart.scroll((self.progress - 0.04) / 0.9); } });
    });

    /* A soft light follows the pointer over the night sections */
    if (fine) {
      var glow = document.createElement('div'); glow.className = 'ln-cursor'; glow.setAttribute('aria-hidden', 'true'); document.body.appendChild(glow);
      var gx = gsap.quickTo(glow, 'x', { duration: 0.6, ease: 'power3.out' }), gy = gsap.quickTo(glow, 'y', { duration: 0.6, ease: 'power3.out' });
      window.addEventListener('pointermove', function (e) {
        gx(e.clientX); gy(e.clientY);
        var over = e.target.closest && e.target.closest('.ln');
        glow.classList.toggle('is-on', !!over && !e.target.closest('a, button, input, [data-ln-scrub]'));
        glow.classList.toggle('is-hot', !!(e.target.closest && e.target.closest('a, button, [data-ln-scrub]')) && !!over);
      }, { passive: true });
      document.addEventListener('pointerleave', function () { glow.classList.remove('is-on', 'is-hot'); });
    }

    /* The oxygen line along the top shows how far down the night you are */
    if (document.body.classList.contains('ln-page')) {
      var bar = document.createElement('div'); bar.className = 'ln-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
      ScrollTrigger.create({ start: 0, end: 'max', onUpdate: function (self) { bar.style.transform = 'scaleX(' + self.progress.toFixed(4) + ')'; } });
    }

    /* Phones lean toward the pointer */
    if (fine) $$('[data-ln-phones]').forEach(function (ph) {
      var frames = $$('.ln-phone__frame', ph).map(function (f) { return { el: f, rx: gsap.quickTo(f, 'rotationX', { duration: 0.8, ease: 'power3.out' }), ry: gsap.quickTo(f, 'rotationY', { duration: 0.8, ease: 'power3.out' }) }; });
      ph.addEventListener('pointermove', function (e) {
        frames.forEach(function (f) { var r = f.el.getBoundingClientRect(); var dx = (e.clientX - (r.left + r.width / 2)) / innerWidth, dy = (e.clientY - (r.top + r.height / 2)) / innerHeight; f.ry(dx * 22); f.rx(-dy * 14); });
      });
      ph.addEventListener('pointerleave', function () { frames.forEach(function (f) { f.rx(0); f.ry(0); }); });
    });

    /* Dawn: the sun rises behind the App */
    $$('[data-ln-dawn]').forEach(function (dawn) {
      gsap.fromTo($('[data-ln-sun]', dawn), { yPercent: 45, scale: 0.75, opacity: 0.4 }, { yPercent: -15, scale: 1.1, opacity: 1, ease: 'none', scrollTrigger: { trigger: dawn, start: 'top bottom', end: '45% center', scrub: true } });
      var morning = $('.ln-morning', dawn);
      if (morning) gsap.fromTo(morning, { letterSpacing: '.08em', opacity: 0 }, { letterSpacing: '-.05em', opacity: 1, ease: 'none', scrollTrigger: { trigger: morning, start: 'top 95%', end: 'top 45%', scrub: true } });
      var phones = $('[data-ln-phones]', dawn);
      if (!phones) return;
      gsap.matchMedia().add('(min-width: 761px)', function () {
        gsap.timeline({ scrollTrigger: { trigger: phones, start: 'top 92%', end: 'top 22%', scrub: 1 } })
          .from($('.ln-phone--l', phones), { xPercent: 104, rotateY: 38, rotateZ: -7, scale: 0.84, ease: 'none' }, 0)
          .from($('.ln-phone--r', phones), { xPercent: -104, rotateY: -38, rotateZ: 7, scale: 0.84, ease: 'none' }, 0)
          .from($('.ln-phone--c', phones), { y: 90, scale: 0.92, ease: 'none' }, 0)
          .from($$('.ln-phone figcaption', phones), { opacity: 0, y: 24, stagger: 0.08, ease: 'none' }, 0.45);
      });
      gsap.matchMedia().add('(max-width: 760px)', function () {
        $$('.ln-phone', phones).forEach(function (p) { gsap.from(p, { y: 70, opacity: 0, duration: 1.1, ease: 'power3.out', scrollTrigger: { trigger: p, start: 'top 88%', once: true } }); });
      });
    });

    /* Line-up cards rise */
    $$('[data-ln-cards]').forEach(function (c) { gsap.from(c.children, { y: 80, opacity: 0, duration: 1.2, ease: 'expo.out', stagger: 0.09, scrollTrigger: { trigger: c, start: 'top 82%', once: true } }); });


    /* Reviews: the score counts up */
    $$('[data-ln-countup]').forEach(function (big) {
      var target = +big.getAttribute('data-ln-countup'), o = { v: 0 };
      gsap.to(o, { v: target, duration: 1.8, ease: 'power3.out', scrollTrigger: { trigger: big, start: 'top 85%', once: true }, onUpdate: function () { big.textContent = o.v.toFixed(1); } });
    });

    /* Brand title brightens */
    $$('.ln-brand__title').forEach(function (t) { gsap.from(t, { opacity: 0.2, ease: 'none', scrollTrigger: { trigger: t, start: 'top 85%', end: 'top 35%', scrub: true } }); });

    // triggers below a pinned scene that was set up later must be measured after it: sort them by page order first
    window.addEventListener('load', function () { ScrollTrigger.sort(); ScrollTrigger.refresh(); });
    var lastH = 0, rt = 0;
    ScrollTrigger.addEventListener('refresh', function () { lastH = document.body.scrollHeight; });
    if ('ResizeObserver' in window) new ResizeObserver(function () {
      if (Math.abs(document.body.scrollHeight - lastH) < 3) return;
      clearTimeout(rt); rt = setTimeout(function () { ScrollTrigger.refresh(); }, 250);
    }).observe(document.body);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
  }
})();
